<template>
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @enter-cancelled="enterCancelled"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
    @leave-cancelled="leaveCancelled"
    :css="false"
  >
    <div v-show="show" style="overflow: hidden">
      <slot />
    </div>
  </transition>
</template>
<script lang="ts">
import {defineComponent} from 'vue';
import gsap from 'gsap';

export default defineComponent({
  name: 'TranReduce',
  props: {
    duration: {
      type: Number,
      default: 0.1,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    async enter(el: HTMLElement, done: () => void) {
      await gsap.to(el, {
        height: this.getContentHeight(el),
        duration: this.duration,
      });
      done();
    },
    beforeEnter(el: HTMLElement) {
      gsap.set(el, {
        height: 0,
      });
    },
    afterEnter(el: HTMLElement) {
      gsap.set(el, {
        height: 'auto',
      });
    },
    enterCancelled() {
      // pass
    },
    async leave(el: HTMLElement, done: () => void) {
      await gsap.to(el, {
        height: 0,
        duration: this.duration,
      });
      done();
    },
    beforeLeave(el: HTMLElement) {
      gsap.set(el, {
        height: this.getContentHeight(el),
      });
    },
    afterLeave(el: HTMLElement) {
      gsap.set(el, {
        height: 'auto',
      });
    },
    leaveCancelled() {
      // pass
    },
    getContentHeight(el: HTMLElement) {
      let height = 0;
      for (const child of el.children) {
        height += child.getClientRects()[0].height;
      }
      return height;
    },
  },
});
</script>
